import {Subscription} from 'rxjs';

export class NamedSubscription {
  public constructor(public name: string, public subscription: Subscription) {}
}
